import { c as _c } from "react/compiler-runtime";
import { HotelCardInfoOptionsPropertiesType } from "@website/accommodation-ui/hotel-card-new/hotel-card-info/hotel-card-info-options/hotel-card-info-options.types";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { MiniChips } from "@website/ui/mini-chips";
import upperFirst from "lodash-es/upperFirst";
import { FC } from "react";
export const HotelCardInfoOptions: FC<HotelCardInfoOptionsPropertiesType> = properties => {
  const $ = _c(12);
  const {
    regularBadges,
    size: t0,
    facilities
  } = properties;
  const size = t0 === undefined ? "responsive" : t0;
  const {
    isMobile
  } = useViewPort();
  if (isMobile && !regularBadges?.length) {
    return null;
  }
  let t1;
  if ($[0] !== facilities || $[1] !== size) {
    t1 = (facilities?.length ?? 0) > 0 && size !== "small" && size !== "xSmall" && <div className="scrollbar-none !hidden flex-wrap items-center gap-1 overflow-x-auto sm:!flex">{facilities?.map(_temp)}</div>;
    $[0] = facilities;
    $[1] = size;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== regularBadges || $[4] !== size) {
    t2 = size !== "small" && size !== "xSmall" && <div className="scrollbar-none flex flex-wrap items-center gap-2 overflow-x-auto">{regularBadges?.map(_temp2)}</div>;
    $[3] = regularBadges;
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex flex-col gap-3">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== properties.className || $[10] !== t3) {
    t4 = <div className={properties.className}>{t3}</div>;
    $[9] = properties.className;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
function _temp(t0) {
  const {
    icon,
    id,
    title
  } = t0;
  return <MiniChips StartIcon={icon ? <MaterialIcon name={icon} variant="outlined" /> : undefined} className="!text-on-surface-medium-emphasis !bg-white" key={id} text={upperFirst(title) ?? ""} />;
}
function _temp2(t0) {
  const {
    text,
    color,
    icon: icon_0,
    textStyle,
    tooltip
  } = t0;
  return <MiniChips StartIcon={icon_0 ? <MaterialIcon className={textStyle} name={icon_0} variant="outlined" /> : undefined} className="!h-[24px] !px-2 !py-1" color={color} key={text} size="medium" text={text ?? ""} textClassName={`text-caption ${color === "#EBECF2" ? "text-on-surface-high-emphasis" : ""}`} tooltip={tooltip} variant="contained" />;
}